import {createStyles} from '@mantine/core';

import {MODEL_HUB_LISTING_TABLE_MAX_HEIGHT_OFFSET_PX} from '../ModelHubConstants';

export const MODEL_HUB_LISTING_TABLE_VERTICAL_SPACING = 14;

export const useModelHubListingTableStyles = createStyles((theme) => ({
  table: {
    '& thead th': {
      backgroundColor: theme.colors.gray[0],
      borderBottom: `1px solid ${theme.colors.gray[3]}`,
      color: theme.colors.gray[6],
      fontSize: 13,
      fontWeight: 600,
      letterSpacing: '0.03em',
      position: 'sticky',
      textTransform: 'uppercase' as const,
      top: 0,
      zIndex: 1,
    },

    '& tbody tr:hover': {
      backgroundColor: theme.colors.gray[0],
    },

    '& tbody tr:focus-visible': {
      outline: `2px solid ${theme.fn.rgba(theme.colors.blue[6], 0.35)}`,
      outlineOffset: -2,
    },

    '& td, & th': {
      verticalAlign: 'middle',
    },
  },
  tablePaper: {
    maxHeight: `calc(100vh - ${MODEL_HUB_LISTING_TABLE_MAX_HEIGHT_OFFSET_PX}px)`,
    overflow: 'auto',
  },
}));
